import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createFolder, downloadFile, listFiles, removeFile, uploadFile } from '../../actions/files.js';
import {
    Container,
    Content,
    Title,
    i18n,
    tokens,
    Files as SbFiles
} from '@simplybenefits/sb-ui-library';

class Files extends PureComponent {
    render() {
        return (
            <Container>
                <Content>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center' }}>
                        <Title title={ i18n.t(tokens.titles.files) } customStyle={{ flex: 1 }} />
                    </div>

                    <SbFiles
                        type="users"
                        id={ this.props.meta.userID }
                        parentFolder="files/Public"
                        dispatch={ this.props.dispatch }
                        listFiles={ listFiles }
                        createFolder={ createFolder }
                        uploadFile={ uploadFile }
                        downloadFile={ downloadFile }
                        removeFile={ removeFile }
                        loader={ this.props.loader }
                    />
                </Content>
            </Container>
        );
    }
}

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    meta: state.user.meta,
    whitelabel: state.whitelabel,
    loader: state.loader
});

export default connect(mapStateToProps)(Files);